import $ from 'jquery';

export const SiteData = {
	data: () => ({
		siteData: null,
	}),
	created: function() {
		$.get( '/wp-json/cp/v1/website' )
			.then( content => this.siteData = content );
	},
};



// WEBPACK FOOTER //
// ./assets/_js/mixins/site-data.js